import { render, staticRenderFns } from "./WelcomeDashboard.vue?vue&type=template&id=4f4b27a9&"
import script from "./WelcomeDashboard.vue?vue&type=script&lang=js&"
export * from "./WelcomeDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports